import React from "react";
import Alert from "react-s-alert";

import {DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {
  AdmissionFromSearch,
  exportAdmissionAuditData,
} from "../../../../services/AdmissionsService";

export const ExportAuditDataDropdownItem = ({
  admission,
  isExportingAuditData,
  setIsExportingAuditData,
  ...props
}: {
  admission: AdmissionFromSearch;
  isExportingAuditData: boolean;
  setIsExportingAuditData: (isExporting: boolean) => void;
}) => {
  const handleExport = async () => {
    if (isExportingAuditData) return;

    setIsExportingAuditData(true);
    try {
      await exportAdmissionAuditData(admission.id);
      Alert.success("Audit data export downloaded successfully");
    } catch (error) {
      Alert.error(
        "Failed to export audit data. Please try again or contact support if the issue persists.",
      );
    } finally {
      setIsExportingAuditData(false);
    }
  };

  return (
    <DropdownMenuItem
      pointer
      onClick={handleExport}
      disabled={isExportingAuditData}
      testId={getResidentTestId(admission, "exportAuditData")}
      {...props}
    >
      {isExportingAuditData ? "Exporting..." : "Export Audit Data"}
    </DropdownMenuItem>
  );
};
